import { render, staticRenderFns } from "./ClinicianTeamFormWrapper.vue?vue&type=template&id=f25af31e"
import script from "./ClinicianTeamFormWrapper.vue?vue&type=script&lang=js"
export * from "./ClinicianTeamFormWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports